import React from 'react';
import Auxiliary from "../../../hoc/Auxiliary";
import DateFormated from "../../Utils/Date/Date";

const CheckedBox = (props) => {
    return (props.content.utcDateStatusReached !== null)?(
        <Auxiliary>
            <li className={`checkedbox ${ props.index === 0 ? "active" : ""}`} >
            <div className="checkedbox__icon"><i className="fas fa-check-circle"></i></div>
                <div className="checkedbox__content">
                    <strong className={` ${props.index === 0 ? 'span--c-green' : ''}`}>
                        { props.lang === "fr" ? props.content.statusReference.nameFr
                            : props.content.statusReference.nameEn }
                    </strong>{'. '}
                    <DateFormated date={props.content.utcDateStatusReached+'Z'} withTime={props.content.statusReference.code !== "L"}/>{'.'}
                </div>
                </li>
        </Auxiliary>
    ):'';
}

export default CheckedBox;
